export const getFirstAndLastName = name => {
  const splittedName = name.split(' ');

  return {
    firstName: splittedName[0],
    lastName: splittedName.splice(1, splittedName.length).join(' '),
  };
};
